import styled from 'styled-components';
import colors from '../../../../../assets/colors';

const Item = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #E9E9E9;

  :last-child { border: none; }

  img {
    width: 45px;
    height: 45px;
    border: 3px solid #E9E9E9;
    border-radius: 50px;
    margin-right: 15px;
  }

  h3 {
    font-size: 0.9rem;
    font-weight: 700;
    color: ${colors.primary};
    letter-spacing: -0.5px;
  }

  p {
    font-size: 0.8rem;
    color: #999;
  }

  button {
    margin-left: 15px;
    padding: 8px 0;
    width: 100px;
  }
`;

export default Item;
